import * as XLSX from 'xlsx';
import { saveAs } from "file-saver";

const generateMessageXlsx = (data, header, title) => {
  try {
    const ws = XLSX.utils.aoa_to_sheet([header]);
    XLSX.utils.sheet_add_json(ws, data, { origin: 'A2', skipHeader: true });

    ws['!cols'] = header.map(h => ({ wch: h.length + 5 }));

    const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };

    XLSX.writeFile(wb, `${title}.xlsx`);
  }
  catch (error) {
    console.log("error", error);
  }
};

export default generateMessageXlsx;
